<template>
  <div v-if="product">
    <MobileMenu v-if="$vuetify.breakpoint.mobile"/>
    <v-row v-if="!$vuetify.breakpoint.mobile">
      <v-col cols="12">
        <v-btn v-for="category in product.categories"
               small
               color="primary"
               tile
               class="mr-1"
               :key="category.id + category.name"
               @click="$router.push(`/category/${category.slug}`)"
        >
          {{ category.name }}
        </v-btn>
        <v-btn v-for="attribute in product.attributes"
               small
               color="primary"
               tile
               class="mr-1"
               :key="attribute.id + attribute.name"
               @click="$router.push(`/attribute/${attribute.slug}`)"
        >
          {{ attribute.name }}
        </v-btn>
        <h1 class="mt-3 title">{{ product.name }}</h1>
      </v-col>
    </v-row>

    <ProductDesktop v-if="!$vuetify.breakpoint.mobile" :product-details="product"/>
    <ProductMobile v-else :product-details="product" />

    <v-row>
      <ProductsBlock v-for="(block, index) in productBlocks"
                     :key="index"
                     :block-type="index"
                     :showVideoTile="block.showVideoTile"
                     :color="block.color"
                     :conditions="block.conditions"
      />
    </v-row>
  </div>
</template>

<script>
import Axios from '@/core/Axios';
import ProductsBlock from '@/components/Partials/ShopBody/ProductsBlock.vue';
import store, { state } from '@/store';
import { translations } from '@/lang/translations';
import Basket from '@/core/Basket';
import MobileMenu from '@/components/Partials/TopBar/MobileMenu.vue';
import ProductDesktop from '@/components/Pages/ProductDesktop.vue';
import ProductMobile from '@/components/Pages/ProductMobile.vue';

export default {
  name: 'ProductView',
  components: {
    ProductMobile, ProductDesktop, MobileMenu, ProductsBlock,
  },
  data() {
    return {
      axios: new Axios(),
      product: null,
      basket: new Basket(),
    };
  },
  mounted() {
    this.selectProductData();
    this.getShopConfig();
  },
  watch: {
    slug() {
      this.selectProductData();
    },
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
    slug() {
      return this.$route.params.slug;
    },
    productBlocks() {
      if (state.config) {
        return JSON.parse(state.config).shopBodyProductBlocks;
      }
      return null;
    },
  },
  methods: {
    getShopConfig() {
      if (state.config === null) {
        this.axios.makeCall('GET', 'norbit/getshopconfig')
          .then((response) => {
            store.commit('setConfig', response.config);
          });
      }
    },
    selectProductData() {
      this.axios.makeCall('GET', `norbit/product/getproduct/${this.slug}`)
        .then((response) => {
          this.product = response;
        })
        .catch(() => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
            this.text.messages.saveError,
          });
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:400,700");

.title {
  font-family: 'Lato', sans-serif;
  color: #555555;
}

</style>
